import { event } from '@uhg-abyss/web/tools/event';

export const widgetModalEvent = (input) => {
  const { modalName } = input;
  event('PSX_DETAILS_WIDGET_MODAL', {
    modalName: modalName?.toLowerCase().replaceAll('-', ''),
  });
};
